import { motion } from "framer-motion";
import {
  Star,
  Phone,
  NavigationArrow,
  Globe,
  Clock,
  MapPin,
  CheckCircle,
} from "@phosphor-icons/react";

const Stars = ({ size = 16 }) => (
  <span className="flex gap-0.5" aria-label="Rated 4.9 out of 5">
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={size} weight="fill" className="text-amber-400" />
    ))}
  </span>
);

export const MapCard = () => (
  <div className="relative" data-testid="hero-map-visual">
    <div
      aria-hidden="true"
      className="absolute inset-0 -z-0 translate-x-6 translate-y-8 rounded-[2.5rem] bg-[#E4EAE0]"
    >
      <MapPin
        size={30}
        weight="fill"
        className="absolute -left-2 top-10 text-pine/30"
      />
      <MapPin
        size={22}
        weight="fill"
        className="absolute bottom-12 right-4 text-ink/20"
      />
    </div>

    <motion.div
      animate={{ y: [0, -12, 0] }}
      transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      className="relative z-10 rounded-[2rem] border border-pine-soft bg-white p-6 shadow-[0_28px_60px_-24px_rgba(26,26,24,0.28)] sm:p-7"
    >
      <div className="flex items-start gap-4">
        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-pine font-heading text-2xl font-extrabold text-cream">
          Y
        </div>
        <div className="min-w-0">
          <p className="truncate font-heading text-xl font-extrabold text-ink">
            Your Business
          </p>
          <p className="text-sm text-soot">Local Service · Your City</p>
          <div className="mt-1.5 flex items-center gap-2">
            <span className="font-heading text-sm font-bold text-ink">4.9</span>
            <Stars />
            <span className="text-xs text-soot">(128 reviews)</span>
          </div>
        </div>
      </div>

      <div className="mt-4 flex items-center gap-2 text-sm text-soot">
        <Clock size={16} weight="duotone" className="text-pine" />
        <span>
          <span className="font-semibold text-pine">Open</span> · Closes 6 PM
        </span>
      </div>

      <div className="mt-5 grid grid-cols-3 gap-2.5">
        {[
          { icon: Phone, label: "Call" },
          { icon: NavigationArrow, label: "Directions" },
          { icon: Globe, label: "Website" },
        ].map((a, i) => (
          <span
            key={i}
            className="flex items-center justify-center gap-1.5 rounded-full border border-pine/25 py-2 text-xs font-bold text-pine"
          >
            <a.icon size={14} weight="bold" />
            {a.label}
          </span>
        ))}
      </div>

      <div className="mt-5 grid grid-cols-3 gap-2.5">
        <div className="h-20 rounded-2xl bg-gradient-to-br from-pine to-emerald-700" />
        <div className="h-20 rounded-2xl bg-gradient-to-br from-[#E8DCC8] to-[#CBB98F]" />
        <div className="h-20 rounded-2xl bg-gradient-to-br from-ink to-[#3A3A34]" />
      </div>

      <ul className="mt-5 space-y-2.5 border-t border-pine-soft pt-5">
        {["Emergency repairs", "Installations", "Free estimates"].map((s) => (
          <li key={s} className="flex items-center gap-2.5 text-sm text-soot">
            <CheckCircle size={18} weight="fill" className="text-pine" />
            {s}
          </li>
        ))}
      </ul>
    </motion.div>

    <motion.div
      animate={{ y: [0, 10, 0] }}
      transition={{ duration: 7, repeat: Infinity, ease: "easeInOut", delay: 1 }}
      className="absolute -left-4 -bottom-8 z-20 w-48 rounded-2xl border border-pine-soft bg-white p-4 shadow-[0_16px_40px_-16px_rgba(26,26,24,0.3)] sm:-left-10"
    >
      <Stars size={13} />
      <p className="mt-2 text-xs font-medium leading-snug text-soot">
        "Fast, friendly, and the price was fair."
      </p>
      <p className="mt-2 text-[11px] font-bold uppercase tracking-wider text-pine">
        New review this week
      </p>
    </motion.div>
  </div>
);
